'use strict';

// Init mobile menu and off-canvas
const mobileMenu = new MobileMenu();
document.addEventListener('mobilemenu-init-done', () => {
	new OffCanvas({
		debug: false,
		overlay: true,
	});
});
mobileMenu.init();

// Responsive tables
document.querySelectorAll('main > table').forEach((table) => {
	const tableWrapper = document.createElement('div');
	tableWrapper.classList.add('table-wrapper');
	tableWrapper.classList.add('overflow-x-auto');
	table.parentNode.insertBefore(tableWrapper, table);
	tableWrapper.appendChild(table);
});

// Cottage galleries
if (document.querySelector('#js-cottage-gallery')) {
	GLightbox();
}
